const VasGetter = {
    vasdata: (state) => state.vasdata,
    vascable: (state) => state.vascable,
    vaspower: (state) => state.vaspower,
};

export default VasGetter;
